import { APIProvider } from '@vis.gl/react-google-maps';
import GoogleMapsProvider from './googleMaps.js';
import QueryProvider from './query.js';
import TRPCProvider from './trpc.js';
import { PuzzleWalletProvider } from '@puzzlehq/sdk';
import { PuzzleGameProvider } from './puzzleProvider.js';

const RootProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <PuzzleWalletProvider>
      <TRPCProvider>
        <QueryProvider>
          <GoogleMapsProvider>
            <APIProvider apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY!}>
              <PuzzleGameProvider>{children}</PuzzleGameProvider>
            </APIProvider>
          </GoogleMapsProvider>
        </QueryProvider>
      </TRPCProvider>
    </PuzzleWalletProvider>
  );
};

export default RootProvider;
